import mixpanel from 'mixpanel-browser'

export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN

export const initAnalytics = () => {
  if (MIXPANEL_TOKEN) {
    mixpanel.init(MIXPANEL_TOKEN)
  }
}
